<script lang="ts">

    export let value: string;
    export let grow = false;

</script>

<input type="text" class:grow bind:value>

<style lang="scss">

    .grow {
       flex-grow: 1;
    }

</style>
